var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-layer"},[(_vm.isNoData)?[_c('div',{staticClass:"no-data-layer__no-data"},[_vm._v("\n      "+_vm._s(_vm.L10n('no-data'))+"\n    ")])]:[_c('div',{staticClass:"no-data-layer__content"},[_vm._t("default")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }